(() => {
  if (customElements.get('slider-video')) return;

  class SliderVideo extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 14,
        watchOverflow: true,
        pagination: {
          el: this.querySelector('[data-pagination]'),
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        }
      });
    }
  }

  customElements.define('slider-video', SliderVideo);
})();
